// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"460":"0b4657cb","547":"0b4657cb","6353":"0b4657cb"}[chunkId] + ".chunk.css");